module.exports = __webpack_public_path__ + "account/assets/checked.59934c1c.svg";